import styled from 'styled-components';
import { Button } from '../../atoms';
import { useAuthStore } from '../../../store/authStore';
import { authService } from '../../../services/authService';
import { getUserTypeLabel } from '../../../constants';
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.header`
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin: 0;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

const UserType = styled.span`
  color: #007bff;
  font-size: 14px;
  font-weight: 600;
  background-color: #e7f3ff;
  padding: 4px 12px;
  border-radius: 12px;
`;

const UserEmail = styled.span`
  color: #666;
  font-size: 13px;
`;

const Header = () => {
  const navigate = useNavigate();
  const { user, userProfile, clearUser } = useAuthStore();

  const handleLogout = async () => {
    try {
      await authService.logout();
      clearUser();
      navigate('/login');
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  return (
    <HeaderContainer>
      <Title>ABA Web</Title>
      <UserInfo>
        <UserDetails>
          <UserType>{getUserTypeLabel(userProfile?.type)}</UserType>
          <UserEmail>{user?.email}</UserEmail>
        </UserDetails>
        <Button variant="secondary" onClick={handleLogout}>
          로그아웃
        </Button>
      </UserInfo>
    </HeaderContainer>
  );
};

export default Header;
